export default __webpack_public_path__ + "static/px1-d0638a2b78e915e7bc70635c9531cddf.jpg";